import { render, staticRenderFns } from "./AdminPages.vue?vue&type=template&id=2afb73ba&scoped=true"
import script from "./AdminPages.vue?vue&type=script&lang=js"
export * from "./AdminPages.vue?vue&type=script&lang=js"
import style0 from "./AdminPages.vue?vue&type=style&index=0&id=2afb73ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb73ba",
  null
  
)

export default component.exports